import { userSlice } from './user';

export { login } from './actions';
export const { setUser, setLoading } = userSlice.actions;

export default userSlice.reducer;
